export default __webpack_public_path__ + "static/media/firebase-logo.ccf86da8.png";